import { Asset } from '../../models/Asset'
import * as api from '../api'
import useInvalidate from '../useInvalidate'
import useApiMutation from './useApiMutation'

export default function useUpdateAsset() {
  const invalidate = useInvalidate()

  return useApiMutation({
    mutationFn: async (
      data: Pick<
        Asset,
        'uuid' | 'learningItemUuid' | 'filename' | 'mimeType' | 'description' | 'visibleFrom' | 'visibleUntil'
      >
    ) => {
      await api.put(`course/${encodeURIComponent(data.learningItemUuid)}/asset/${encodeURIComponent(data.uuid)}`, {
        filename: data.filename,
        mime_type: data.mimeType,
        description: data.description,
        visible_from: data.visibleFrom?.toISOString(),
        visible_until: data.visibleUntil?.toISOString(),
      })

      await invalidate.assets()
    },
  })
}
